import {
  SnippetElement,
  defineElement,
  on,
  param,
  query,
  queryAll,
  wait
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/snippets/shop-all-categories/shop-all-categories.ts
var ShopAllCategories = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.isMouseInside = false;
  }
  handleHoverExit() {
    return __async(this, null, function* () {
      this.isMouseInside = false;
      this.closeAllChildren();
      this.disableHover();
      yield this.hideBackdrop();
    });
  }
  connectedCallback() {
    if (this.leaveEventDisabled == true)
      return;
    this.menuContainer.addEventListener("mouseleave", () => this.handleHoverExit());
  }
  handleHoverEnter() {
    return __async(this, null, function* () {
      this.isMouseInside = true;
      yield this.showBackdrop();
    });
  }
  hideBackdrop() {
    return __async(this, null, function* () {
      this.backdrop.classList.add("opacity-0");
      this.backdrop.classList.remove("opacity-100");
      yield wait(200);
      if (!this.isMouseInside) {
        this.backdrop.classList.add("hidden");
        this.menuContainer.style.zIndex = "0";
      } else {
        this.showBackdrop();
      }
    });
  }
  showBackdrop() {
    return __async(this, null, function* () {
      this.menuContainer.style.zIndex = "100";
      this.backdrop.classList.remove("hidden");
      yield wait(3);
      this.backdrop.classList.add("opacity-100");
      this.backdrop.classList.remove("opacity-0");
    });
  }
  handleHoverTarget(element) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      const menuTarget = element.dataset.menuTarget;
      const menuParent = element.dataset.menuParent;
      const subMenuParent = element.dataset.subMenuParent;
      if (menuParent && menuParent !== "none") {
        this.parentMenu = this.querySelector(`[data-menu="${menuParent}"]`);
      } else {
        this.parentMenu = void 0;
      }
      if (menuTarget && menuTarget !== "none" && menuTarget !== "keep") {
        this.currentMenu = this.querySelector(`[data-menu="${menuTarget}"]`);
      } else if (menuTarget !== "keep") {
        this.currentMenu = void 0;
      }
      if (subMenuParent && subMenuParent !== "none") {
        this.subMenuParent = this.querySelector(`[data-menu="${subMenuParent}"]`);
      } else {
        this.subMenuParent = void 0;
      }
      this.querySelectorAll("[data-menu]").forEach((menu) => {
        menu.classList.remove("flex");
        menu.classList.add("hidden");
      });
      this.disableHover();
      const toShow = [element];
      if (this.parentMenu) {
        const pElement = this.parentMenu.parentElement.children[0];
        toShow.push(pElement);
      }
      if (this.subMenuParent) {
        const pElement = this.subMenuParent.parentElement.children[0];
        toShow.push(pElement);
      }
      this.showHover(toShow);
      (_a = this.currentMenu) == null ? void 0 : _a.classList.remove("hidden");
      (_b = this.currentMenu) == null ? void 0 : _b.classList.add("flex");
      (_c = this.parentMenu) == null ? void 0 : _c.classList.remove("hidden");
      (_d = this.parentMenu) == null ? void 0 : _d.classList.add("flex");
    });
  }
  disableHover() {
    this.querySelectorAll("[data-menu-target]").forEach((element) => {
      var _a;
      for (const child of element.children[0].children) {
        if (child.tagName.toLowerCase() === "img") {
          child.classList.remove("shop-menu-icon");
        }
        child.classList.remove("!text-primary");
      }
      if (((_a = element.children[1]) == null ? void 0 : _a.tagName.toLowerCase()) === "svg") {
        element.children[1].classList.remove("!text-primary");
      }
    });
  }
  showHover(elements) {
    var _a;
    for (const element of elements) {
      for (const child of element.children[0].children) {
        if (child.tagName.toLowerCase() === "img") {
          child.classList.add("shop-menu-icon");
        }
        child.classList.add("!text-primary");
      }
      if (((_a = element.children[1]) == null ? void 0 : _a.tagName.toLowerCase()) === "svg") {
        element.children[1].classList.add("!text-primary");
      }
    }
  }
  closeAllChildren() {
    this.querySelectorAll("[data-menu]").forEach((menu) => {
      menu.classList.remove("flex");
      menu.classList.add("hidden");
    });
  }
};
__decorateClass([
  queryAll("[data-link]")
], ShopAllCategories.prototype, "linkElements", 2);
__decorateClass([
  query("[data-menu-backdrop]")
], ShopAllCategories.prototype, "backdrop", 2);
__decorateClass([
  query("[data-menu-container]")
], ShopAllCategories.prototype, "menuContainer", 2);
__decorateClass([
  param("leaveEventDisabled")
], ShopAllCategories.prototype, "leaveEventDisabled", 2);
__decorateClass([
  on("mouseenter", "[data-menu-container]")
], ShopAllCategories.prototype, "handleHoverEnter", 1);
__decorateClass([
  on("mouseenter", "[data-menu-target]")
], ShopAllCategories.prototype, "handleHoverTarget", 1);
ShopAllCategories = __decorateClass([
  defineElement("shop-all-categories")
], ShopAllCategories);
export {
  ShopAllCategories
};
